<template>
  <v-card class="money-card" outlined elevation="0">
    <!-- <v-icon
      v-if="hasFilterFunction"
      :color="filterActive ? 'primary' : 'grey lighten-1'"
      class="filter-button"
      @click="toggleFilter"
    >
      mdi-filter-variant
    </v-icon> -->

    <v-card-text class="pa-3">
      <div class="d-flex align-center justify-space-between mb-2">
        <div class="caption font-weight-bold text-uppercase grey--text text--darken-1">
          {{ headerText }}
        </div>

        <v-avatar size="30" tile class="card-icon" :style="{ backgroundColor: avatarColor }">
          <v-img
          v-if="iconSvg"
          :src="iconSvg"
          contain
          max-width="24"
          max-height="24"
          />
          <v-icon v-else size="18" :color="iconColor">{{ icon }}</v-icon>
        </v-avatar>
      </div>

      <div class="subtitle-1 font-weight-bold text-end mb-0">
        {{ total }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'money-total-card',
  props: {
    icon: String,
    iconSvg: String,
    headerText: String,
    total: String,
    filterFunction: Function,
    avatarColor: {
      type: String,
      default: '#eef6ff',
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      filterActive: false,
    };
  },
  computed: {
    hasFilterFunction() {
      return this.filterFunction !== undefined;
    },
  },
  methods: {
    toggleFilter() {
      this.filterActive = !this.filterActive;
      if (this.filterFunction) {
        this.filterFunction(this.filterActive);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.money-card {
  position: relative;
  border-radius: 6px;
  border-color: #e5e7eb !important;
}

.filter-button {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
  cursor: pointer;
}

.card-icon {
  background-color: #eef6ff;
}
</style>
